function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhilipsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 173,
    height: 173,
    viewBox: "0 0 173 173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M339.283-465.162h-9.133v11.893h-9.508v-11.893h-9.133v29.921h9.133v-11.77h9.508v11.77h9.133zm31.771 23.909v-23.909h-9.134v29.921h16.515l1.373-6.012zm-15.886-23.909h-9.133v29.921h9.133zm37.027 0h-9.129v29.921h9.129zm45.029 7.637c0-1.629 1.629-2.381 4.252-2.381a22.879 22.879 0 0 1 8.134 1.509l-.748-6.514a35.721 35.721 0 0 0-8.381-.876c-7.382 0-12.386 2.913-12.386 9.014 0 10.515 14.266 8.389 14.266 13.271 0 1.875-1.382 2.874-4.758 2.874a27.317 27.317 0 0 1-10.383-2.377l1 6.888a30.145 30.145 0 0 0 9.508 1.5c7.628 0 13.883-2.5 13.883-10.018 0-10.009-14.389-8.134-14.389-12.892m-25.763 15.15c8.5 0 13.883-4.384 13.883-12.02 0-8.385-5.753-11.391-15.137-11.391a103.123 103.123 0 0 0-11.132.625v29.921h9.133v-7.135h3.253zm4.877-11.893c0 3.878-1.875 6.51-6.633 6.51h-1.5v-12.365c.532-.03 1.029-.03 1.5-.03 4.5 0 6.633 2.126 6.633 5.885M294-442.376c8.5 0 13.883-4.384 13.883-12.02 0-8.385-5.753-11.391-15.133-11.391a103.2 103.2 0 0 0-11.136.625v29.921h9.133v-7.135zm4.881-11.893c0 3.878-1.879 6.51-6.633 6.51h-1.5v-12.365c.531-.03 1.033-.03 1.5-.03 4.5 0 6.633 2.126 6.633 5.885",
    transform: "translate(-280 536.787)",
    style: {
      fill: "#0b5ed7"
    },
    "data-name": "Group 10384"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhilipsLogo);
export default __webpack_public_path__ + "static/media/philips-logo.b7d67a300ea38ed7620d194e12307f01.svg";
export { ForwardRef as ReactComponent };